export default "__VITE_ASSET__BFUBRa6J__"